import { createAutoCorrectedDatePipe } from 'text-mask-addons';

interface IMaskConfig {
  guide?: boolean;
  pipe?: (value: string) => string;
  keepCharPositions?: boolean;
  placeholderChar?: string;
  ngxMask: string;
}

export interface TextMasks {
  [key: string]: IMaskConfig;
}

export const SharedMasks: TextMasks = {

  phoneMask: {
    guide: false,
    placeholderChar: '\u2000',
    ngxMask: '(000) 000-0000'
  },

  expirationMask: {
    pipe: createAutoCorrectedDatePipe('mm/yy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
    ngxMask: '00/00'
  },

  birthdayMask: {
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
    ngxMask: '00/00/0000'
  },

  zipcodeMask: {
    guide: false,
    placeholderChar: '\u2000',
    ngxMask: '00000'
  }
};
